export default __webpack_public_path__ + "static/media/pm2-5_white.2e7a06c8.png";